if (!customElements.get('product-part-button')) {
  customElements.define(
    'product-part-button',
    class ProductPartButton extends HTMLElement {
      lenData;
      constructor() {
        super();

      }

      connectedCallback() {
        this.input = this.querySelector("input");
        this.input.addEventListener("change", this.onChange.bind(this))
        if (!(this.dataset.display_type && this.dataset.display_type == 'Color')) {
          this.initContainerHover();
        }
      }

      disconnectedCallback() {
        // console.log("ProductDisplay disconnectedCallback");
        this.input.removeEventListener("change", this.onChange.bind(this))

      }
      initContainerHover() {
        if (this.dataset.lenid) {
          this.lenData = window.lens[this.dataset.lenid];
          console.log(this.lenData);
          
          const elHover = document.createElement("div")
          this.append(elHover);
          const elHoverID = "hover-container-" + Math.random();
          elHover.id = elHoverID;
          elHover.style.display = "none";
          $(`#${this.id}`).hover(() => {

            elHover.style.display = "block";

          }, () => {
            elHover.style.display = "none";
          });
          const lenData = [
            { title: "Light condition", key: "weather_condition" },
            { title: "VLT", key: "vlt_percentage" },
            { title: "Lens Category", key: "lens_category" },
            { title: "Material", key: "material" },
            { title: "Lens type", key: "lens_type" },
            { title: "POLARIZED", key: "is_polarized" },

          ]

          var htmlNeedRender = '';
          for (let index = 0; index < lenData.length; index++) {
            const element = lenData[index];
            let item = this.getVLTValue(element.key);
            if (item) {
              htmlNeedRender += `<tr>
              <th><strong>${element.title}</strong></th>
              <td>${item}</td>
            </tr>`
            }
          }
          elHover.className = "len-hover lens-hover-detials"
          elHover.innerHTML = `<div class="arrow-up"></div>
          <table >
          ${htmlNeedRender}
        </table>`
          // console.log($(`.button-variant`));
          // $(`.tooltip-test`).tooltip({
          //   template: 
          // })
        }
      }
      getVLTTable(key) {
        switch (key) {
          case value:

            break;

          default:
            break;
        }
        return `<tr>
            <th><strong>Light condition</strong></th>
            <td>${this.getVLTValue("weather_condition")}</td>
          </tr>`;
      }
      getVLTValue(key) {
        if (key == 'weather_condition') {
          if (this.lenData[key] && this.lenData[key].length > 0) {
            return `<img style="width:30px; height:30px" src=${this.lenData[key][0].image}>`
          }
          return undefined;
        }
        if (key == 'vlt_percentage') {
          return this.lenData[key] + "%";
        }
        return this.lenData[key];
      }
      onChange(res) {
        // console.log("change", this.dataset.part, this.dataset, res.target.dataset);
        this.sendEventPartChanged();
      }

      sendEventPartChanged() {
        publish(PUB_SUB_EVENTS.productPartChange, {
          source: 'product-part-button',
          data: this.dataset
        });
        this.setActivePart(this.dataset.part, this.dataset.partvalue)
      }
      setActivePart(partName, partValue) {
        // 
        var lsChilds = document.getElementsByTagName("product-part-button");
        for (let index = 0; index < lsChilds.length; index++) {
          const element = lsChilds[index];
          if (element.dataset.part == partName && element.dataset.partvalue == partValue) {
            element.querySelector("input").setAttribute("checked", "true");
          }
        }
        // document.getElementById("btn-part-value-" + partName + "-" + partValue)?.setAttribute("checked", "true");
      }

    }
  );
}
